import { format } from 'date-fns';
import { useCallback } from 'react';
import { TIME_FORMAT } from './time-format';

export const useFormatTime = () => useCallback((date: Date) => format(date, TIME_FORMAT), []);
